var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { OmitType, PartialType, PickType } from "@nestjs/swagger";
import { Type } from "class-transformer";
import { IsArray, IsBoolean, IsDate, IsEnum, IsNumber, IsObject, IsOptional, IsString, ValidateIf, ValidateNested } from "class-validator";
export var WebhookConfigurationStatus;
(function (WebhookConfigurationStatus) {
    WebhookConfigurationStatus["ACTIVE"] = "ACTIVE";
    WebhookConfigurationStatus["PAUSED"] = "PAUSED";
    WebhookConfigurationStatus["PAUSED_AUTOMATICALLY"] = "PAUSED_AUTOMATICALLY";
})(WebhookConfigurationStatus || (WebhookConfigurationStatus = {}));
export var WebhookDeliveryStatus;
(function (WebhookDeliveryStatus) {
    WebhookDeliveryStatus["DELIVERED"] = "DELIVERED";
    WebhookDeliveryStatus["FAILED"] = "FAILED";
    WebhookDeliveryStatus["RETRIED"] = "RETRIED";
})(WebhookDeliveryStatus || (WebhookDeliveryStatus = {}));
export class OrganizationWebhookConfigurationDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], OrganizationWebhookConfigurationDto.prototype, "id", void 0);
__decorate([
    IsString()
], OrganizationWebhookConfigurationDto.prototype, "name", void 0);
__decorate([
    IsString()
], OrganizationWebhookConfigurationDto.prototype, "webhookUrl", void 0);
__decorate([
    ValidateIf((_, value) => value !== null),
    IsArray(),
    IsString({ each: true })
], OrganizationWebhookConfigurationDto.prototype, "studyScope", void 0);
__decorate([
    IsArray(),
    IsString({ each: true })
], OrganizationWebhookConfigurationDto.prototype, "eventTypes", void 0);
__decorate([
    IsEnum(WebhookConfigurationStatus)
], OrganizationWebhookConfigurationDto.prototype, "status", void 0);
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], OrganizationWebhookConfigurationDto.prototype, "previousWebhookSecretExpiresAt", void 0);
__decorate([
    IsString()
], OrganizationWebhookConfigurationDto.prototype, "webhookSecretLast4", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], OrganizationWebhookConfigurationDto.prototype, "createdAt", void 0);
__decorate([
    Type(() => Date),
    IsDate()
], OrganizationWebhookConfigurationDto.prototype, "updatedAt", void 0);
export class OrganizationWebhookConfigurationWithRecentDeliveryLogsDto extends OrganizationWebhookConfigurationDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    Type(() => Date),
    IsDate(),
    IsOptional()
], OrganizationWebhookConfigurationWithRecentDeliveryLogsDto.prototype, "lastDeliveryLogTimestamp", void 0);
__decorate([
    IsArray(),
    IsEnum(WebhookDeliveryStatus, { each: true })
], OrganizationWebhookConfigurationWithRecentDeliveryLogsDto.prototype, "recentStatuses", void 0);
export class CreateOrganizationWebhookConfigurationInput extends PickType(OrganizationWebhookConfigurationDto, [
    "name",
    "webhookUrl",
    "studyScope",
    "eventTypes",
]) {
}
__decorate([
    IsEnum(WebhookConfigurationStatus),
    IsOptional()
], CreateOrganizationWebhookConfigurationInput.prototype, "status", void 0);
export class UpdateOrganizationWebhookConfigurationInput extends PartialType(CreateOrganizationWebhookConfigurationInput) {
}
export class RotateOrganizationWebhookConfigurationSecretInput {
}
__decorate([
    IsNumber(),
    IsOptional()
], RotateOrganizationWebhookConfigurationSecretInput.prototype, "gracePeriodHours", void 0);
export class WebhookProjectDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], WebhookProjectDto.prototype, "id", void 0);
__decorate([
    IsString()
], WebhookProjectDto.prototype, "title", void 0);
export class OrganizationWebhookConfigurationDisplayDto extends OrganizationWebhookConfigurationWithRecentDeliveryLogsDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    ValidateIf((_, value) => value !== null),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => WebhookProjectDto)
], OrganizationWebhookConfigurationDisplayDto.prototype, "studyScopeProjects", void 0);
export class OrganizationWebhookConfigurationCreationDto extends OrganizationWebhookConfigurationWithRecentDeliveryLogsDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], OrganizationWebhookConfigurationCreationDto.prototype, "webhookSecret", void 0);
export class OrganizationWebhookConfigurationCreationDisplayDto extends OrganizationWebhookConfigurationDisplayDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], OrganizationWebhookConfigurationCreationDisplayDto.prototype, "webhookSecret", void 0);
export class OrganizationWebhookConfigurationWithSecretsDto extends OrganizationWebhookConfigurationDto {
    constructor(fields) {
        super(fields);
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], OrganizationWebhookConfigurationWithSecretsDto.prototype, "webhookSecret", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationWebhookConfigurationWithSecretsDto.prototype, "previousWebhookSecret", void 0);
export class OrganizationWebhookConfigurationsResult {
}
__decorate([
    IsNumber()
], OrganizationWebhookConfigurationsResult.prototype, "total", void 0);
__decorate([
    Type(() => OrganizationWebhookConfigurationDto),
    ValidateNested({ each: true })
], OrganizationWebhookConfigurationsResult.prototype, "results", void 0);
export class OrganizationWebhookConfigurationsDisplayResult {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsNumber()
], OrganizationWebhookConfigurationsDisplayResult.prototype, "total", void 0);
__decorate([
    Type(() => OrganizationWebhookConfigurationDisplayDto),
    ValidateNested({ each: true })
], OrganizationWebhookConfigurationsDisplayResult.prototype, "results", void 0);
export class OrganizationWebhookDeliveryLogDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsString()
], OrganizationWebhookDeliveryLogDto.prototype, "id", void 0);
__decorate([
    IsString()
], OrganizationWebhookDeliveryLogDto.prototype, "organizationWebhookConfigurationId", void 0);
__decorate([
    IsString()
], OrganizationWebhookDeliveryLogDto.prototype, "messageId", void 0);
__decorate([
    IsDate(),
    Type(() => Date)
], OrganizationWebhookDeliveryLogDto.prototype, "timestamp", void 0);
__decorate([
    IsString()
], OrganizationWebhookDeliveryLogDto.prototype, "eventType", void 0);
__decorate([
    Type(() => WebhookProjectDto),
    ValidateNested()
], OrganizationWebhookDeliveryLogDto.prototype, "project", void 0);
__decorate([
    IsBoolean()
], OrganizationWebhookDeliveryLogDto.prototype, "success", void 0);
__decorate([
    IsNumber()
], OrganizationWebhookDeliveryLogDto.prototype, "attempt", void 0);
__decorate([
    IsBoolean()
], OrganizationWebhookDeliveryLogDto.prototype, "willRetry", void 0);
__decorate([
    IsObject()
], OrganizationWebhookDeliveryLogDto.prototype, "eventHeaders", void 0);
__decorate([
    IsObject()
], OrganizationWebhookDeliveryLogDto.prototype, "eventData", void 0);
__decorate([
    IsString()
], OrganizationWebhookDeliveryLogDto.prototype, "responseSummary", void 0);
__decorate([
    IsString(),
    IsOptional()
], OrganizationWebhookDeliveryLogDto.prototype, "responseBody", void 0);
__decorate([
    IsNumber(),
    IsOptional()
], OrganizationWebhookDeliveryLogDto.prototype, "responseTimeMs", void 0);
export class OrganizationWebhookDeliveryLogInput extends OmitType(OrganizationWebhookDeliveryLogDto, ["id", "project"]) {
}
__decorate([
    IsString()
], OrganizationWebhookDeliveryLogInput.prototype, "projectId", void 0);
export class WebhookSearchInput {
}
__decorate([
    IsString(),
    IsOptional()
], WebhookSearchInput.prototype, "text", void 0);
__decorate([
    IsEnum(WebhookDeliveryStatus),
    IsOptional()
], WebhookSearchInput.prototype, "status", void 0);
export class WebhookDeliveryLogsSearchResultDto {
    constructor(fields) {
        Object.assign(this, fields);
    }
}
__decorate([
    IsNumber()
], WebhookDeliveryLogsSearchResultDto.prototype, "total", void 0);
__decorate([
    Type(() => OrganizationWebhookDeliveryLogDto),
    ValidateNested({ each: true })
], WebhookDeliveryLogsSearchResultDto.prototype, "results", void 0);
